export default function Switch(props) {
  const { input, disabled, wrapperClasses, label } = props;
  const id = `${input.name}-${input.value}`

  return (
    <div className={`switch ${wrapperClasses} ${disabled && 'disabled'}`}>
      <div className="custom-control custom-switch">
        <input type="checkbox" className="custom-control-input" id={id} {...input} checked={input.value} disabled={disabled} />
        <label className="custom-control-label" htmlFor={id}>{label}</label>
      </div>
    </div>
  )
}